import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getUsers, removeUser } from '../../../actions/usersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Users() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const [userList, setUserList] = useState(null) 
    const {users, loading, result} = useSelector(state=>state.users)
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getUsers())
    }, [dispatch])

    useEffect(()=>{
        let filterUsers = users?.filter(user => user.rol !== 'Superadmin');

        setUserList(filterUsers)
    }, [users])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('users.itsok'),
                    icon: 'error',
                    text: t('users.'+result.message+'0') + result.count + t('users.'+result.message+'1')
                })
                dispatch({
                    type: 'USER_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('users.letsok'),
                    icon: 'success',
                    text: t('users.deleteduser')
                })
                dispatch({
                    type: 'USER_RESET_RESULT'
                })
            }
        }
    }, [result, dispatch, t])

    const deleteUser = (idUser) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeUser(idUser))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('users.firstname'),
            cell: datos =>
                <div>
                    {datos.firstname}&nbsp;{datos.lastname}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('users.rol'),
            cell: datos =>
                <div>
                    {t('users.'+datos.rol)}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/user/`+datos._id}>
                    <i className="fas fa-user-edit"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteUser(datos._id)}>
                    <i className="fas fa-user-minus"></i>
                </Button>
            </>
        }
    ]
  
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('users.edituser')}</h1> 
                        <label className='mb-2'>{t('users.selectuser')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/user`}>
                                <i className="fas fa-user-plus"></i> {t('users.add')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {userList 
                                ?
                                    <CustomDataTable columns={columns} data={userList} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}